import { User } from "@app/core/user/domain/user";

export class UserMapper {
  static deserialize(data: any): User {
    return new User({
      name: data.name,
      lastName: data.last_name,
      dni: data.dni,
      email: data.email,
      dateOfBirth: data.date_birth,
      image: data.image,
      acceptedPolicies: data.accepted_policies,
      accepted_communications: data.accepted_communications,
      adult: data.accepted_policies,
    });
  }

  static serialize(user: User): any {
    return {
      name: user.name,
      last_name: user.lastName,
      dni: user.dni,
      email: user.email,
      date_birth: user.dateOfBirth,
      accepted_policies: user.acceptedPolicies,
      accepted_communications: user.accepted_communications,
      adult: user.adult,
      // If the image has correct value, send it, otherwise, don't send it
      ...(hasImageCorrectValue(user.image) ? { image: user.image ?? "" } : {}),
    };
  }
}

/**
 * Check if the image has a correct value
 * @param image
 */
function hasImageCorrectValue(image: string | null): boolean {
  // If the image is null, then it means that the user wants to remove the image
  if (image == null) {
    return true;
  }
  return isBase64(image);
}
/**
 * Check if the image is base64 encoded
 * @param image
 */
function isBase64(image: string | null) {
  if (image == null) {
    return false;
  }
  // Check if the image is base64 encoded using a regex.
  // The regex checks if the image starts with "data:image/*;base64" where * can be any character.
  return /^data:image\/?[A-z]*;base64/.test(image);
}
